/* Interaction is drawn in ink. Seal is never a button fill, a border or a ring —
   the only red in this file is --fill-destructive, which the Delete now confirm owns
   and check-brand.sh counts (at most two declarations: base and hover). */

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--sp-s);
  padding-inline: var(--sp-m);
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  font-family: var(--font-sans);
  font-size: var(--step-n1);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color var(--dur-1) var(--ease), border-color var(--dur-1) var(--ease),
    color var(--dur-1) var(--ease);
}

.button:disabled {
  cursor: not-allowed;
  color: var(--text-disabled);
  background: transparent;
  border-color: var(--border);
}

.block {
  display: flex;
  width: 100%;
}

/* ---- sizes ---- */

.sm {
  height: var(--ctl-h-sm);
  padding-inline: var(--sp-s);
}

.md {
  height: var(--ctl-h-md);
}

.lg {
  height: var(--ctl-h-lg);
  padding-inline: var(--sp-l);
  font-size: var(--step-0);
}

/* A finger is not a pointer. On touch every small control — row actions, copy, the dialog
   Close — takes the medium height; a desktop keeps the dense 28px. */
@media (pointer: coarse) {
  .sm {
    block-size: var(--ctl-h-md);
  }
}

/* ---- variants ---- */

.primary {
  background: var(--interactive);
  color: var(--interactive-text);
  border-color: var(--interactive);
}

.primary:hover:not(:disabled) {
  background: var(--interactive-hover);
  border-color: var(--interactive-hover);
}

.primary:active:not(:disabled) {
  background: var(--interactive-active);
  border-color: var(--interactive-active);
}

.secondary {
  background: transparent;
  color: var(--text);
  border-color: var(--border-control);
}

.secondary:hover:not(:disabled) {
  background: var(--bg-hover);
}

.secondary:active:not(:disabled) {
  background: var(--bg-selected);
}

.ghost {
  background: transparent;
  color: var(--text-muted);
  padding-inline: var(--sp-s);
}

.ghost:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text);
}

/* The one critical fill in the product. */
.destructive {
  background: var(--fill-destructive);
  color: var(--on-fill-destructive);
  border-color: var(--fill-destructive);
}

.destructive:hover:not(:disabled) {
  background: var(--fill-destructive-hover);
  border-color: var(--fill-destructive-hover);
}
